// @flow
import { CLEAR_NID_STRING, SET_NID_STRING, } from '../actions/nid';

import type { Action } from './types';

const initialState = {
    nidString: "",
};

//Reducer that manages a playlist
export default function nid( state = initialState, action: Action ) {
    switch ( action.type ) {

        case SET_NID_STRING:
            const { nidString } = action;
            return { ...state, nidString: nidString };
        case CLEAR_NID_STRING:
            return initialState;
        default:
            return state;
    }
}